const util = require('./util');
const productUtil = require('./pages/product/productUtil');
const bonusProductsView = require('./bonus-products-view');
const dialog = require('./dialog');

const timer = {
    id: null,
    clear() {
        if (this.id) {
            window.clearTimeout(this.id);
            delete this.id;
        }
    },
    start(duration, callback) {
        this.id = setTimeout(callback, duration);
    },
};

function makeUrlQuickViewFromMiniCart(url, source, productListID) {
    let newUrl = url;
    if (source) {
        newUrl = util.appendParamToURL(newUrl, 'source', source);
    }
    if (productListID) {
        newUrl = util.appendParamToURL(newUrl, 'productlistid', productListID);
    }
    newUrl = util.appendParamToURL(newUrl, 'minicartQuickView', true);
    return newUrl;
}

function show(options) {
    let $link = $('#QuickViewDialog');

    if ($link.length === 0) {
        $link = $('<div/>').attr('id', 'QuickViewDialog').appendTo(document.body);
    }
    const url = makeUrlQuickViewFromMiniCart(options.url, options.source, options.productlistid);
    dialog.open({
        target: $link,
        url,
        options: {
            width: 950,
            dialogClass: 'no-title',
            open() {
                if (typeof options.callback === 'function') { options.callback(); }
            },
        },
    });
}

const minicart = {
    init() {
        this.downpaymentModal();
        this.$el = $('#mini-cart');
        this.$content = this.$el.find('.mini-cart-content');

        // events
        this.$el.find('.mini-cart-total').on('mouseenter', () => {
            if (this.$content.not(':visible')) {
                this.slide();
                $('.mini-cart-link').attr('aria-expanded', 'true');
            }
        });

        this.$content.on('mouseenter', () => {
            timer.clear();
        }).on('mouseleave', () => {
            timer.clear();
            timer.start(30, this.close.bind(this));
            $('.mini-cart-link').attr('aria-expanded', 'false');
        });
    },
    /**
     * @function
     * @description Shows the given content in the mini cart
     * @param {String} A HTML string with the content which will be shown
     */
    show(html) {
        this.$el.html(html);
        this.init();
        this.slide();
        if ($('.mini-cart-content').hasClass('limit-error')) {
            util.scrollBrowser(0, () => {
                productUtil.showLimitErrorDialog();
            });
        } else {
            util.scrollBrowser(0);
        }
        $('.mini-cart-link').focus();
        this.setFocus();
    },
    /**
     * @function
     * @description Shows the given content in the add to cart dialog
     * @param {String} A HTML string with the content which will be shown
     */
    showmodal(html) {
        this.$el.html(html);
        this.openModal();
        this.initializeMiniCartEvents();
        this.initializeQuickViewAddToCart();
    },
    /**
     * @function
     * @description Slides down and show the contents of the mini cart
     */
    slide() {
        timer.clear();
        // show the item
        this.$content.slideDown('slow');
        // after a time out automatically close it
        timer.start(6000, this.close.bind(this));
        $('.mini-cart-link').attr('aria-expanded', 'true');
    },
    /**
     * @function
     * @description Closes the mini cart with given delay
     * @param {Number} delay The delay in milliseconds
     */
    close(delay) {
        timer.clear();
        this.$content.slideUp(delay);
        $('.mini-cart-link').attr('aria-expanded', 'false');
    },
    /**
     * @function
     * @description Sets up the focus events for the mini cart
     */
    setFocus() {
        /**
         * @listener
         * @description Set the aria-expanded value to true, show the mini cart and focus on the mini cart header when the mini cart icon is focused or moused over
         */
        $('.mini-cart-link').on('focus mouseenter', (e) => {
            $(e.currentTarget).attr('aria-expanded', 'true');

            if (!$(e.currentTarget).parent().next('.mini-cart-content').is(':visible')) {
                $(e.currentTarget).parent().next('.mini-cart-content').show();
            }

            $('.mini-cart-header').focus();
        });

        /**
         * @listener
         * @description Set the aria-expanded value to false when the mini cart is hidden
         */
        $('.mini-cart-link-checkout').on('blur', () => {
            $('.mini-cart-content').hide();
            $('.mini-cart-link').attr('aria-expanded', 'false');
        });

        /**
         * @listener
         * @description Allow the user to exit out of the mini cart via keyboard via the escape key
         */
        $('.mini-cart-link').on('keyup', (e) => {
            if (e.keyCode === 27) {
                $(e.currentTarget).attr('aria-expanded', 'false');
                $(e.currentTarget).parent().next('.mini-cart-content').hide();
            }
        });
    },
    /**
     * @function
     * @description Open Add to Cart Modal
     */
    openModal() {
        const atcModal = $('.mini-cart-content-modal');
        atcModal.dialog({
            width: 820,
            autoOpen: false,
            modal: true,
            dialogClass: 'add-to-cart-dialog',
            open() {
                // move the title html into the dialog titlebar element; can't pass in as string
                $('.ui-dialog-title').html($('.add-to-cart-dialog-title').html());
                $('.add-to-cart-dialog-title').remove();
                $('.ui-widget-overlay').addClass('atc-overlay');
                $(document).on('click', '.atc-overlay', () => {
                    try {
                        $('.ui-dialog-content').dialog().dialog('close');
                    } catch (e) {
                        // Ignore exceptions thrown if the customer rapidly clicks the overlay
                    }
                });
            },
            close() {
                // remove dialog from DOM
                atcModal.dialog('destroy').remove();
            },
            position: {
                my: 'center top',
                at: 'center top+3',
                of: window,
                collision: 'flipfit',
            },
        });

        atcModal.dialog('open');
        atcModal.find('.close-modal').on('click', () => {
            $('.ui-dialog-content').dialog().dialog('close');
        });
        atcModal.find('.select-bonus').on('click', (e) => {
            e.preventDefault();
            bonusProductsView.show(e.currentTarget.href);
        });
        util.initDynamicCarousel('.add-to-cart-modal-recommendations [id^="cq_recomm_slot"]', '.tiles-container', 0, 3);
    },

    downpaymentModal() {
        const atcModal = $('.downpayment-modal');
        if (atcModal && atcModal.length) {
            atcModal.dialog({
                width: 560,
                autoOpen: false,
                modal: true,
                dialogClass: 'down-payment-dialog',
                open() {
                    // move the title html into the dialog titlebar element; can't pass in as string
                    $('.ui-dialog-title').html($('.downpayment-modal-title').html());
                    $('.downpayment-modal-title').remove();
                    $('.ui-widget-overlay').addClass('atc-overlay');
                    $(document).on('click', '.atc-overlay', () => {
                        try {
                            $('.ui-dialog-content').dialog().dialog('close');
                        } catch (e) {
                            // Ignore exceptions thrown if the customer rapidly clicks the overlay
                        }
                    });
                },
                close() {
                    // Trigger custom event when downpayment modal closes
                    $(document).trigger('downpaymentModalClosed');

                    // remove dialog from DOM
                    atcModal.dialog('destroy').remove();
                },
                position: {
                    my: 'center top',
                    at: 'center top+3',
                    of: window,
                    collision: 'flipfit',
                },
            });
            atcModal.dialog('open');

            atcModal.find('.close-modal').on('click', () => {
                $('.ui-dialog-content').dialog().dialog('close');
            });
        }
    },
    initializeMiniCartEvents() {
        try {
            $('.minicartProductForm').on('submit', (e) => {
                e.preventDefault();
                const data = $(e.currentTarget).serialize();
                $.ajax({
                    type: 'POST',
                    url: Urls.upsellAddProduct,
                    data,
                    success: (response) => {
                        if (response && response.error) {
                            productUtil.showLimitErrorDialog();
                        }
                        const atcModal = $('.mini-cart-content-modal');
                        atcModal.dialog('destroy').remove();
                        minicart.showmodal(response);
                        // initializeMiniCartEvents();
                        this.initializeQuickViewAddToCart();
                    },
                });
            });
        } catch (e) {
            console.error('Error_In_initializeMiniCartEvents : ', e);
        }
    },
    initializeQuickViewAddToCart() {
        $('.mini-cart-quick-view.pdpForm').on('submit', (e) => {
            e.preventDefault();
            const data = $(e.currentTarget).serialize();
            const url = Urls.upsellAddProduct;
            $.ajax({
                type: 'POST',
                url,
                data,
                success: (response) => {
                    if (response && response.error) {
                        productUtil.showLimitErrorDialog();
                    }
                    const atcModal = $('.mini-cart-content-modal');
                    atcModal.dialog('destroy').remove();
                    dialog.close();
                    this.showmodal(response);
                    this.initializeMiniCartEvents();
                },
            });
        });

        $('.upsell-items .thumb-link, .upsell-product-image-container .product-image.main-image').on('click', (e) => {
            e.preventDefault();
        });

        $('.upsell-product-tile .product-image, .upsell-product-tile .product-name').on('click', (e) => {
            if ($(e.currentTarget).parents('.product-tile').hasClass('disable-quickview')) {
                return;
            }

            const productUrl = $(e.currentTarget).attr('data-product-url');
            show({
                url: productUrl,
                source: 'quickview',
                callback: () => {
                    this.initializeQuickViewAddToCart();
                },
            });
        });
    },
};

module.exports = minicart;
